(function() {
  'use strict';

  // =========================================================================
  // 1. VALIDAZIONE RIGOROSA VARIANT ID SHOPIFY
  // =========================================================================
  function isValidShopifyVariantId(id) {
    return id && /^\d{10,}$/.test(id.toString().trim());
  }

  // =========================================================================
  // 2. ESTRAZIONE SICURA DEL VARIANT ID
  // =========================================================================
  function getVariantId(swatch) {
    // A. Se il bottone cliccato ha un vero Variant ID associato
    if (swatch) {
      const directVariantId = swatch.getAttribute('data-variant-id') || 
                              swatch.getAttribute('data-js-variant-id');
      if (isValidShopifyVariantId(directVariantId)) return directVariantId;
    }

    // B. Fonte primaria: input [name="id"] nel form del prodotto
    const formInput = document.querySelector('form[action*="/cart/add"] [name="id"], .product-form [name="id"], [name="id"]');
    if (formInput && isValidShopifyVariantId(formInput.value)) {
      return formInput.value;
    }

    // C. Parametro URL (?variant=...)
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (isValidShopifyVariantId(urlVariant)) return urlVariant;

    return null;
  }

  // =========================================================================
  // 3. LOGIC LAYER: CONTROLLO ORARI DIFFERENZIATI (PHONE vs WHATSAPP)
  // =========================================================================
  function isChannelOpen(channelType) {
    const configEl = document.getElementById('StoreBusinessHoursConfig');
    if (!configEl) return true; // Fallback di sicurezza se manca il Metafield

    try {
      const rawText = configEl.textContent.trim();
      if (!rawText) return true;
      
      let config;
      try {
        config = JSON.parse(rawText);
      } catch (err) {
        try {
          // Riparazione avanzata:
          // 1. Frecce Ruby =>
          // 2. Chiavi e numeri senza doppi apici (es. 0: o schedule:)
          // 3. Virgolette singole in doppie
          // 4. Virgole finali prima di parentesi chiuse (,)
          const sanitized = rawText
            .replace(/=>/g, ':')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
            .replace(/'/g, '"')
            .replace(/,\s*([}\]])/g, '$1');

          config = JSON.parse(sanitized);
        } catch (repairErr) {
          // Se il JSON è irrecuperabile, fallback silenzioso ad APERTO senza sporcare la console
          return true;
        }
      }
      if (typeof config === 'string') config = JSON.parse(config);
      if (!config) return true;

      const now = new Date();
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: config.timezone || 'Europe/Rome',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      });

      const parts = formatter.formatToParts(now).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});

      // 1. Controllo Festività (YYYY-MM-DD)
      const currentDateStr = `${parts.year}-${parts.month}-${parts.day}`;
      if (config.holidays && Array.isArray(config.holidays) && config.holidays.includes(currentDateStr)) {
        return false;
      }

      // 2. Giorno della settimana nel fuso orario target (0 = Dom, 1 = Lun, ..., 6 = Sab)
      const romeDate = new Date(Date.UTC(parseInt(parts.year, 10), parseInt(parts.month, 10) - 1, parseInt(parts.day, 10)));
      const dayOfWeek = romeDate.getUTCDay().toString();

      // 3. Tabella orari specifica per il canale
      const schedule = config[`${channelType}_schedule`] || config.schedule || {};
      const todaySlots = schedule[dayOfWeek];
      if (!todaySlots || todaySlots.length === 0) {
        return false; // Chiuso tutto il giorno
      }

      // 4. Minuti correnti dall'inizio della giornata
      const currentMinutes = parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10);

      // 5. Verifica se l'ora attuale rientra in uno degli slot di apertura
      return todaySlots.some(([start, end]) => {
        const [sH, sM] = start.split(':').map(Number);
        const [eH, eM] = end.split(':').map(Number);
        return currentMinutes >= (sH * 60 + sM) && currentMinutes < (eH * 60 + eM);
      });
    } catch (e) {
      // Fallback silenzioso di sicurezza: evita console.error che penalizza Lighthouse
      return true;
    }
  }

  // =========================================================================
  // 4.A AGGIORNAMENTO RITIRO IN NEGOZIO (Section Rendering API)
  // =========================================================================
  function updatePickupBadge(variantId) {
    if (!isValidShopifyVariantId(variantId)) return;
    
    const container = document.getElementById('Shella-Pickup-Container');
    if (!container) return;

    const fetchUrl = `${window.location.pathname}?variant=${variantId}&section_id=product-pickup-availability`;

    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network error on pickup fetch');
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newContent = doc.querySelector('#Shella-Pickup-Container') || 
                           doc.querySelector('#shopify-section-product-pickup-availability') ||
                           doc.querySelector('.product-page-info__pickup-availability');
        
        if (newContent && container) {
          if (container.innerHTML.trim() !== newContent.innerHTML.trim()) {
            container.innerHTML = newContent.innerHTML;

            // Riattiva i pop-up di Shella (Mappa e Orari)
            if (window.theme && window.theme.Popups && typeof window.theme.Popups.init === 'function') {
              window.theme.Popups.init();
            }
          }
        }
      })
      .catch(() => {});
  }

  // =========================================================================
  // 4.B AGGIORNAMENTO DINAMICO SCHEDA WHATSAPP & ORDINE TELEFONICO (VIDEO vs TAGLIE)
  // =========================================================================
  function updateWhatsAppLink(variantId) {
    if (!isValidShopifyVariantId(variantId)) return;
    
    const waWrapper = document.querySelector('.product-page-info__whatsapp-block, .product-page-info__whatsapp');
    const waLink = document.querySelector('.js-product-whatsapp-link');
    const waJsonScript = document.querySelector('.js-product-variants-wa-json');
    const pickupContainer = document.getElementById('Shella-Pickup-Container');
    const phoneCtas = document.querySelectorAll('.phone-order-micro-cta, .phone-order-chip-wrapper');
    
    // Controlli orari indipendenti (fuso Europe/Rome anti-cache)
    const isPhoneOpen = isChannelOpen('phone');
    const isWhatsAppOpen = isChannelOpen('whatsapp');
    const isVideoOpen = isChannelOpen('whatsapp_video');

    if (!waLink || !waJsonScript || !waWrapper) return;

    let variantsData = {};
    try {
      variantsData = JSON.parse(waJsonScript.textContent);
    } catch (e) { return; }

    const variant = variantsData[variantId];
    if (!variant) return;

    // 1. Telefono Fisso: Visibile SOLO se Aperto da orario E SE LA TAGLIA È DISPONIBILE
    phoneCtas.forEach(el => {
      el.style.display = (isPhoneOpen && variant.available) ? '' : 'none';
    });

    // 2. Determina la Priorità della Card WhatsApp
    const isDropship = waLink.getAttribute('data-is-dropship') === 'true';
    const hasLocalStock = !isDropship; // Se non è Melluso/CafèNoir, è in negozio.
    let mode = null;

    // PRIORITÀ 1: VIDEO (In orario video + Scarpa fisicamente presente a Baricella)
    if (isVideoOpen && hasLocalStock && variant.available) {
      mode = 'video';
    } 
    // PRIORITÀ 2: CONSIGLIO TAGLIA (In orario WhatsApp generico + Taglia disponibile)
    else if (isWhatsAppOpen && variant.available) {
      mode = 'size';
    }

    // PRIORITÀ 3: CHIUSO / ESAURITO -> Nascondi del tutto WhatsApp ed espandi il Ritiro al 100%
    if (!mode) {
      waWrapper.style.setProperty('display', 'none', 'important');
      if (pickupContainer) {
        pickupContainer.style.setProperty('width', '100%', 'important');
      }
      return;
    }

    // 3. Se Aperto: Mostra WhatsApp (50%) e ripristina la larghezza di Baricella (50%)
    waWrapper.style.setProperty('display', '', '');
    if (pickupContainer) {
      pickupContainer.style.removeProperty('width');
    }

    // 4. Aggiorna Dinamicamente Titolo e Sottotitolo
    const titleEl = waLink.querySelector('.js-wa-title') || waLink.querySelector('strong');
    const subtitleEl = waLink.querySelector('.js-wa-subtitle') || waLink.querySelector('span');

    const titleText = waLink.getAttribute(mode === 'video' ? 'data-video-title' : 'data-size-title');
    const subtitleText = waLink.getAttribute(mode === 'video' ? 'data-video-subtitle' : 'data-size-subtitle');

    if (titleEl && titleText) titleEl.textContent = titleText;
    if (subtitleEl && subtitleText) subtitleEl.innerHTML = subtitleText;

    // 5. Costruzione URL e Messaggio Precompilato
    const phone = waLink.getAttribute('data-phone') || '393516873091';
    const productTitle = waLink.getAttribute('data-product-title') || '';
    
    let rawUrl = waLink.getAttribute('data-product-url') || window.location.pathname;
    rawUrl = rawUrl.split('?')[0]; 
    const finalUrl = `${rawUrl}?variant=${variantId}`;
    
    const skuText = (variant.sku && variant.sku.toString().trim() !== '') ? ` (SKU: ${variant.sku.toString().trim()})` : '';

    // Legge il template del messaggio dal Liquid o applica il fallback
    const rawTemplate = waLink.getAttribute(mode === 'video' ? 'data-video-message' : 'data-size-message');
    let message = '';

    if (rawTemplate) {
      message = rawTemplate
        .replace(/\[SIZE\]/g, variant.title)
        .replace(/\[SKU\]/g, skuText)
        .replace(/\[URL\]/g, finalUrl);
    } else {
      const currentLang = (document.documentElement.lang || 'it').toLowerCase().slice(0, 2);
      if (mode === 'video') {
        message = currentLang === 'en'
          ? `Hello! I'm looking at ${productTitle} on your website. Is it possible to get a quick live video from the store for size ${variant.title}${skuText}?\n\nLink: ${finalUrl}`
          : `Ciao! Sto guardando ${productTitle} sul vostro sito. È possibile avere un breve video dal vivo dal negozio per il numero ${variant.title}${skuText}?\n\nLink: ${finalUrl}`;
      } else {
        message = currentLang === 'en'
          ? `Hello! I'm looking at ${productTitle} on your website. Could you give me advice on sizing for size ${variant.title}${skuText}? How does this model fit?\n\nLink: ${finalUrl}`
          : `Ciao! Sto guardando ${productTitle} sul vostro sito. Vorrei un consiglio sulla calzata per il numero ${variant.title}${skuText}. Come calza questo modello?\n\nLink: ${finalUrl}`;
      }
    }

    waLink.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    if (titleText) waLink.setAttribute('title', titleText);
    waLink.classList.add('is-ready');
  }

  // =========================================================================
  // 4.C ESECUZIONE COORDINATA DEI SERVIZI (CON PROTEZIONE ANTI-DOPPIONI)
  // =========================================================================
  let lastSyncedVariantId = null;
  function syncProductServices(variantId) {
    if (!isValidShopifyVariantId(variantId) || lastSyncedVariantId === variantId) return;
    lastSyncedVariantId = variantId;
    updatePickupBadge(variantId);
    updateWhatsAppLink(variantId);
  }

  // =========================================================================
  // 5. EVENT LISTENERS: CLICK SUGLI SWATCH (TAGLIA/COLORE)
  // =========================================================================
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('[data-js-option-value], .product-options__value, [data-value], .product-page-info__options-item');
    if (swatch) {
      setTimeout(function() {
        // Timeout a 200ms per dare tempo al tema Shella di aggiornare la pagina
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        const formInput = document.querySelector('form[action*="/cart/add"] [name="id"], .product-form [name="id"], [name="id"]');
        
        // Prende la variante nuova dall'URL o dal Form, scartando quella vecchia
        const variantId = urlVariant || (formInput && formInput.value ? formInput.value : getVariantId(swatch));
        
        if (isValidShopifyVariantId(variantId)) {
          syncProductServices(variantId);
        }
      }, 200); 
    }
  });

  // =========================================================================
  // 6. EVENT LISTENERS: CHANGE SU MENU A TENDINA (ACCESSIBILITÀ & MOBILE)
  // =========================================================================
  document.addEventListener('change', function(e) {
    if (e.target.name === 'id' || e.target.closest('select[name="id"]') || e.target.closest('[data-js-product-variants="control"]')) {
      const variantId = e.target.value;
      if (isValidShopifyVariantId(variantId)) {
        syncProductServices(variantId);
      }
    }
  });

  // =========================================================================
  // 7. CRONOLOGIA BROWSER & INTERCETTAZIONE REPLACESTATE (ANTI-LAG MOBILE)
  // =========================================================================
  ['pushState', 'replaceState'].forEach(function(method) {
    const originalMethod = history[method];
    history[method] = function() {
      const result = originalMethod.apply(this, arguments);
      try {
        // Legge all'istante il nuovo URL appena Shella lo aggiorna
        const targetUrl = arguments[2] || window.location.href;
        const newVariantId = new URL(targetUrl, window.location.origin).searchParams.get('variant');
        if (isValidShopifyVariantId(newVariantId)) {
          syncProductServices(newVariantId);
        }
      } catch (err) {}
      return result;
    };
  });

  window.addEventListener('popstate', function() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (isValidShopifyVariantId(urlVariant)) {
      syncProductServices(urlVariant);
    }
  });

  // =========================================================================
  // 8. SUPPORTO THEME EDITOR SHOPIFY (LIVE SECTION / BLOCK RELOAD)
  // =========================================================================
  if (window.Shopify && window.Shopify.designMode) {
    const handleEditorRefresh = function(event) {
      if (event.detail && (event.detail.sectionId || event.detail.blockId)) {
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        const variantId = isValidShopifyVariantId(urlVariant) ? urlVariant : getVariantId();
        if (variantId) {
          syncProductServices(variantId);
        }
      }
    };
    document.addEventListener('shopify:section:load', handleEditorRefresh);
    document.addEventListener('shopify:block:select', handleEditorRefresh);
  }

  // =========================================================================
  // 9. INIZIALIZZAZIONE AUTOMATICA ALL'APERTURA DELLA PAGINA
  // =========================================================================
  function initOnPageLoad() {
    // Se il prodotto è esaurito e Shella nasconde i selettori, recupera la variante dal JSON
    let initialVariantId = getVariantId();
    
    if (!initialVariantId) {
      const waJsonScript = document.querySelector('.js-product-variants-wa-json');
      if (waJsonScript) {
        try {
          const variantsData = JSON.parse(waJsonScript.textContent);
          const ids = Object.keys(variantsData);
          if (ids.length > 0) initialVariantId = ids[0];
        } catch (e) {}
      }
    }

    if (initialVariantId) {
      syncProductServices(initialVariantId);
    } else {
      // Se è esaurito totale o non trova nulla, NASCONDI SEMPRE telefono e WA
      document.querySelectorAll('.phone-order-micro-cta, .phone-order-chip-wrapper').forEach(el => {
        el.style.display = 'none';
      });

      const waWrapper = document.querySelector('.product-page-info__whatsapp-block, .product-page-info__whatsapp');
      if (waWrapper) waWrapper.style.setProperty('display', 'none', 'important');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnPageLoad);
  } else {
    initOnPageLoad();
  }
})();

/* ==========================================================================
   FIX FULLSCREEN SHELLA: Ultra-HD dinamico con MutationObserver (Zero Bug)
   Massima compatibilità Slick/Swipe, zero ritardi
   ========================================================================== */
(function() {
  function upgradeImageToHD(img) {
    if (!img || img.tagName !== 'IMG') return;
    var masterUrl = img.getAttribute('data-master');
    if (!masterUrl) return;

    // Gestisce sia i vecchi URL con {width} che i nuovi URL nativi Shopify
    var hdUrl = masterUrl.replace(/_\{width\}x\./, '_2048x.').replace(/\{width\}/, '2048');
    
    if (img.src !== hdUrl && hdUrl.indexOf('{width}') === -1) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = hdUrl;
    }
  }

  function initFullscreenObserver() {
    var fsContainer = document.querySelector('[data-js-product-gallery-fullscreen]');
    if (!fsContainer) return;

    // 1. Processa immediatamente le immagini già presenti nel DOM
    var existingImages = fsContainer.querySelectorAll('img');
    existingImages.forEach(upgradeImageToHD);

    // 2. Protezione anti-duplicazione: registra l'Observer UNA SOLA VOLTA
    if (fsContainer.dataset.fsObserved === 'true') return;
    fsContainer.dataset.fsObserved = 'true';

    // 3. Osserva l'iniezione dinamica di nuove slide durante lo Swipe o i click sulle Frecce
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Elemento HTML
            if (node.tagName === 'IMG') upgradeImageToHD(node);
            if (node.querySelectorAll) {
              node.querySelectorAll('img').forEach(upgradeImageToHD);
            }
          }
        });
      });
    });

    observer.observe(fsContainer, { childList: true, subtree: true });
  }

  // 1. Se l'utente clicca sulla "X" per chiudere la galleria, ripristina lo scroll ed esce
  document.addEventListener('click', function(e) {
    if (e.target.closest('.product-gallery__fullscreen_close')) {
      document.body.style.overflow = ''; // <-- SBLOCCA LO SFONDO
      return; // Esce subito, evita conflitti con l'apertura
    }

    // 2. Se l'utente clicca per APRIRE la galleria (sulle foto o sul tasto ingrandisci)
    if (e.target.closest('.product-gallery__control_fullscreen, [data-js-product-gallery-main-item], .product-gallery__main_item')) {
      document.body.style.overflow = 'hidden'; // <-- BLOCCA LO SFONDO
      requestAnimationFrame(initFullscreenObserver);
    }
  });
})();

/* ==========================================================================
   FIX RESIZE & ROTAZIONE FULLSCREEN (Moderno, Debounced & Anti-Crash)
   ========================================================================== */
(function() {
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var fsContainer = document.querySelector('[data-js-product-gallery-fullscreen]');
      if (fsContainer && !fsContainer.classList.contains('d-none')) {
        var fsSlider = fsContainer.querySelector('[data-js-product-gallery-fullscreen-slider]');
        if (fsSlider && window.jQuery && window.jQuery(fsSlider).hasClass('slick-initialized')) {
          window.jQuery(fsSlider).slick('setPosition');
        }
      }
    }, 200);
  });
})();